// extracted by mini-css-extract-plugin
module.exports = {"userNameBox":"antd-pro-containers-student-views-styles-userNameBox","smallAvat":"antd-pro-containers-student-views-styles-smallAvat"};